import { useEffect } from "react";
import { AppLoading } from "@/components/layout/app-loading";

/** Sends the browser to another site (the website) and shows the loading screen for the moment that takes. */
export function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return <AppLoading />;
}
